<template>
    <el-dropdown trigger="click" class="international" @command="handleSetLanguage">
        <div style="color: #cdcdcd;padding-right: 14px;">
            <span v-if="language == 'zh'">中文</span>
            <span v-if="language == 'en'">EN</span>
            <span v-if="language == 'rus'">Русский язык</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :disabled="language === 'zh'" command="zh"> 中文 </el-dropdown-item>
            <el-dropdown-item :disabled="language === 'en'" command="en"> EN </el-dropdown-item>
            <el-dropdown-item :disabled="language === 'rus'" command="rus"> Русский язык </el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</template>

<script>
export default {
    data() {
        return {
            language: this.$i18n.locale,
            Newcustom: {},
        };
    },
    mounted() {
        this.$i18n.locale = localStorage.getItem("lang") || 'zh';
    },
    methods: {
        handleSetLanguage(lang) {
            this.$i18n.locale = lang;
            this.language = lang;
            localStorage.setItem("lang", lang);
        },
    },
};
</script>
